import * as $ from 'jquery';
import 'slick-carousel';

class Carousel {
	init = () => {
		const carousels = Array.from(
			document.querySelectorAll<HTMLElement>('[data-carousel]')
		);

		carousels.forEach((carousel) => {
			this.slickInit(carousel);
		});
	};

	slickInit(el: HTMLElement) {

    const carouselTarget = el.querySelector('[data-carousel-target]');
    const autoplaySpeed = el.getAttribute('data-autoplay-speed') ? parseInt(el.getAttribute('data-autoplay-speed')!, 10) : 4000;


		const slickSettings: JQuerySlickOptions = {
			dots: false,
			// appendArrows: el.parentElement.querySelector('.slick-controls'),
			prevArrow: el.querySelector('[data-slick-prev]'),
			nextArrow: el.querySelector('[data-slick-next]'),
			// variableWidth: true,
			adaptiveHeight: true,
			infinite: true,
			slidesToScroll: 1,
			fade: true,
			autoplay: true,

			autoplaySpeed: autoplaySpeed,

			pauseOnHover: false,
		};
		const slick = $(carouselTarget).slick(slickSettings);

		const pauseBtn = el.querySelector('[data-slick-pause]');

		if(pauseBtn) {
			pauseBtn.addEventListener('click', e => {
				const btn = <HTMLButtonElement>e.currentTarget;
				if(btn.classList.contains('pause')) {
					slick.slick('slickPlay');
					btn.classList.remove('pause');
				} else {
					slick.slick('slickPause');
					btn.classList.add('pause');
				}
			});
		}
	}
}

const carouselInstance = new Carousel();
carouselInstance.init();
